import { render, staticRenderFns } from "./GatekeeperInviteCoordinators.vue?vue&type=template&id=43e53f83&"
import script from "./GatekeeperInviteCoordinators.vue?vue&type=script&lang=js&"
export * from "./GatekeeperInviteCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports